import { createSelector } from '@reduxjs/toolkit'

export const selectSelectedHeader = createSelector(
  [(state) => state.generalSlice.selectedHeader],
  (selectedHeader) => selectedHeader
)
